import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from './layouts/AppLayout';
import { PublicLayout } from './layouts/PublicLayout';
import { ToastViewport } from './components/ui/Toast';
import { LoadingPanel } from './components/ui/Spinner';
import { ErrorBoundary } from './components/ErrorBoundary';
import { RequireAuth } from './components/auth/RequireAuth';
import { HomePage } from './pages/HomePage';

// Route-level code splitting keeps the landing page small.
const DashboardPage = lazy(() => import('./pages/DashboardPage'));
const NewAnalysisPage = lazy(() => import('./pages/NewAnalysisPage'));
const AnalysisPage = lazy(() => import('./pages/AnalysisPage'));
const ProjectsPage = lazy(() => import('./pages/ProjectsPage'));
const ProjectDetailPage = lazy(() => import('./pages/ProjectDetailPage'));
const HistoryPage = lazy(() => import('./pages/HistoryPage'));
const SettingsPage = lazy(() => import('./pages/SettingsPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

export function App() {
  return (
    <ErrorBoundary>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[70] focus:rounded-md focus:bg-accent focus:px-4 focus:py-2 focus:text-sm focus:text-accent-fg"
      >
        Skip to content
      </a>

      <Suspense fallback={<LoadingPanel label="Loading page" />}>
        <Routes>
          {/*
            Public: the front page and the one result a guest just generated
            there. Everything that manages state across visits - dashboard,
            projects, history, settings, the full analysis form - requires
            signing in, below.
          */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/analyses/:id" element={<AnalysisPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>

          <Route element={<RequireAuth />}>
            <Route element={<AppLayout />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/analyses/new" element={<NewAnalysisPage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/projects/:id" element={<ProjectDetailPage />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/analyses" element={<Navigate to="/history" replace />} />
            </Route>
          </Route>
        </Routes>
      </Suspense>

      <ToastViewport />
    </ErrorBoundary>
  );
}
